import { FetchError } from "@medusajs/js-sdk";
import { HttpTypes } from "@medusajs/types";

import { UseMutationOptions, useMutation } from "@tanstack/react-query";

import { sdk } from "../../lib/client";

export const useSignInWithEmailPass = (
  options?: UseMutationOptions<
    | string
    | {
        location: string;
      },
    FetchError,
    HttpTypes.AdminSignUpWithEmailPassword
  >,
) => {
  return useMutation({
    mutationFn: (payload) => sdk.auth.login("user", "emailpass", payload),
    onSuccess: async (data, variables, context) => {
      options?.onSuccess?.(data, variables, context);
    },
    ...options,
  });
};

export const useSignUpWithEmailPass = (
  options?: UseMutationOptions<
    string,
    FetchError,
    HttpTypes.AdminSignInWithEmailPassword
  >,
) => {
  return useMutation({
    mutationFn: (payload) => sdk.auth.register("user", "emailpass", payload),
    onSuccess: async (data, variables, context) => {
      options?.onSuccess?.(data, variables, context);
    },
    ...options,
  });
};

export const useResetPasswordForEmailPass = (
  options?: UseMutationOptions<void, FetchError, { email: string }>,
) => {
  const clientType = import.meta.env.VITE_CLIENT_TYPE || "";
  const hostname = import.meta.env.VITE_CLIENT_HOSTNAME || "";
  const customHeaders = {
    "Content-Type": "application/json",
    Accept: "text/html",
    "x-client-hostname": hostname,
    "x-client-type": clientType,
  };
  return useMutation({
    mutationFn: (payload) =>
      sdk.client.fetch(`/auth/user/emailpass/reset-password`, {
        method: "POST",
        body: {
          identifier: payload.email,
        },
        headers: customHeaders,
      }),
    onSuccess: async (data, variables, context) => {
      options?.onSuccess?.(data, variables, context);
    },
    ...options,
  });
};

export const useLogout = (options?: UseMutationOptions<void, FetchError>) => {
  return useMutation({
    mutationFn: () => sdk.auth.logout(),
    ...options,
  });
};

export const useUpdateProviderForEmailPass = (
  token: string,
  options?: UseMutationOptions<void, FetchError, HttpTypes.AdminUpdateProvider>,
) => {
  return useMutation({
    mutationFn: (payload) =>
      sdk.auth.updateProvider("user", "emailpass", payload, token),
    onSuccess: async (data, variables, context) => {
      options?.onSuccess?.(data, variables, context);
    },
    ...options,
  });
};
